module.exports = Symbol.for('nodejs.util.inspect.custom')
